export default __webpack_public_path__ + "static/media/christmasLogo.67f4dc38.png";